import { Route, Switch } from "wouter";
import { useAuth } from "./hooks/useAuth.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { Login } from "./pages/Login.js";
import { Register } from "./pages/Register.js";
import { Dashboard } from "./pages/Dashboard.js";
import { Sites } from "./pages/Sites.js";
import { Brain } from "./pages/Brain.js";
import { Agents } from "./pages/Agents.js";
import { Pipelines } from "./pages/Pipelines.js";
import { Notifications } from "./pages/Notifications.js";
import { LLMGateway } from "./pages/LLMGateway.js";
import { Memory } from "./pages/Memory.js";
import { System } from "./pages/System.js";
import { Organization } from "./pages/Organization.js";
import { DashboardLayout } from "./components/DashboardLayout.js";
import { Vault } from "./pages/Vault.js";
import { Chat } from "./pages/Chat.js";
import { Channels } from "./pages/Channels.js";
import { Security } from "./pages/Security.js";
import { Tools } from "./pages/Tools.js";
import { Logs } from "./pages/Logs.js";
import { Governance } from "./pages/Governance.js";
import { Integrations } from "./pages/Integrations.js";
import { Skills } from "./pages/Skills.js";
// Office foi unificado com Brain — rota /office redireciona para /brain

function AuthenticatedApp() {
  return (
    <DashboardLayout>
      <ErrorBoundary>
        <Switch>
          <Route path="/" component={Dashboard} />
          <Route path="/sites" component={Sites} />
          <Route path="/brain" component={Brain} />
          <Route path="/agents" component={Agents} />
          <Route path="/pipelines" component={Pipelines} />
          <Route path="/llm" component={LLMGateway} />
          <Route path="/memory" component={Memory} />
          <Route path="/system" component={System} />
          <Route path="/organization" component={Organization} />
          <Route path="/notifications" component={Notifications} />
          <Route path="/vault" component={Vault} />
          <Route path="/chat" component={Chat} />
          <Route path="/channels" component={Channels} />
          <Route path="/security" component={Security} />
          <Route path="/plugins">{() => { window.location.href = "/integrations"; return null; }}</Route>
          <Route path="/tools" component={Tools} />
          <Route path="/logs" component={Logs} />
          <Route path="/governance" component={Governance} />
          <Route path="/integrations" component={Integrations} />
          <Route path="/constitution">{() => { window.location.href = "/governance"; return null; }}</Route>
          <Route path="/skills" component={Skills} />
          {/* Office unificado com Brain — redirect */}
          <Route path="/office">{() => { window.location.href = "/brain"; return null; }}</Route>
          <Route>
            <div className="flex items-center justify-center h-full">
              <p className="text-muted-foreground">Página não encontrada</p>
            </div>
          </Route>
        </Switch>
      </ErrorBoundary>
    </DashboardLayout>
  );
}

export function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-primary/20" />
          <p className="text-muted-foreground text-sm">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <ErrorBoundary>
        <Switch>
          <Route path="/register" component={Register} />
          <Route component={Login} />
        </Switch>
      </ErrorBoundary>
    );
  }

  return <AuthenticatedApp />;
}
